import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Link} from 'react-router-dom';
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import { DATATABLE_CONFIG, LEAVE_REQUEST_ID } from '../../../shared/Config';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';
class LeaveRequestList extends Component {
    state = {
        display : true,
        globalFilter: null,
        selectedItems:[],
        loadOnce:true
    }
 

    statusRender = (rowData, column) => {

        let status = <Button type="button" label="Pending" className="p-button-warning p-button-rounded" ></Button>
        if (rowData.status === null || undefined) {
            status = <Button type="button" label="Saved as Draft" className="p-button-info p-button-rounded" ></Button>
        } else if (rowData.status === 'Approved') {
            status = <Button type="button" label="Approved" className="p-button-success p-button-rounded" ></Button>
        } else if (rowData.status === 'Canceled') {
            status = <Button type="button" label="Canceled" className="p-button-danger p-button-rounded" ></Button>
        } else if (rowData.status === 'Closed') {
            status = <Button type="button" label="Closed" className="p-button-success p-button-rounded" ></Button>
        } else if (rowData.status === 'Rejected') {
            status = <Button type="button" label="Rejected" className="p-button-danger p-button-rounded" ></Button>
        }

        return <div className="actionCenter">
            {status}
        </div>;
    }

    actionTemplate = (rowData) => {
        return <div className="actionCenter">
            <Link to={"/leave-request/edit/"+rowData.requestId}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            <Link to={"/leave-request/view/"+rowData.requestId}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
          
          
        </div>;
    }


    delete = () => {

        if(this.state.selectedCustomers.length > 0){


        const updatedDocValue = this.state.selectedCustomers.map( (value,index) => {
            return index;
        })
        const filteredValue = this.state.dataTableValue.filter((doc,ind) => {

            return updatedDocValue.includes(ind) === false;
         
        });
        this.setState({dataTableValue:filteredValue})
        }
        else{
            this.growl.show({severity: 'error', summary: null, detail: 'Please select checkbox'});
        }

    }

    componentDidMount(){
      
        // this.props.getRequest();
        console.log("entred")
    }
  
    render() {   

        const { requestListData } = this.props;

        let tableData = [];
        tableData = requestListData && requestListData[0] && requestListData[0].filter(list => list.processId === 'b5585767-17f2-43d4-979b-efd170b4c3fa' && list.requestFrom === "My Request") || [];
        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

        return (
            <div className="p-grid search">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Leave Request</h1>
               
                        <div className="p-grid">
                            
                            <div className="p-col-12 p-lg-12">
                                <div className="mt1">

                                <Link to="/leave-request/add/new"><Button style={{float: 'right'}} label="Add Leave Request" icon="pi pi-plus" className="ml1" /></Link>

                                </div>                                
                            </div>
                      
                        <div className="p-col-12" >
                        <DataTable value={tableData}   
                         selection={this.state.selectedItems} onSelectionChange={e => this.setState({selectedItems: e.value})}
                        globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG} >
                                <Column selectionMode="multiple" style={{width:'3em'}}/>
                                <Column field="requestNum" header="Request Number" sortable={true} />
                                <Column field="requesterName" header="Requester Name" sortable={true} />
                                <Column field="requesterNumber" header="Requester Number" sortable={true}/>
                                {/* <Column field="requestType" header="Leave Type"/> */}
                                <Column field="remark" header="Remark"sortable={true}/>
                                <Column field="pendingWith" header="Pending With"sortable={true}/>
                                <Column field="status" header="Status" body={this.statusRender} sortable={true}/>
                                <Column body={this.actionTemplate} header="Action" style={{textAlign:'center', width: '8em'}}/>
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userPref : state.auth.userPref,
        Employee : (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        tableLists: state.master.tableLists,
        userDetail : state.auth.userDetail,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        requestListData: state.master.requestListData,
    }
}
  
const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getRequest: (value,processid) => dispatch(actions.getRequest(value,'B5585767-17F2-43D4-979B-EFD170B4C3FA')),

    }
}
export default connect(mapStateToProps,mapDispatchToProps)(LeaveRequestList);